import axios, { AxiosRequestHeaders } from "axios";
import { useRef, useState } from "react";
import { ILoginData2 } from "../../../models";
import { HOSTNAME } from "../api-utils";
import { ApiTesterComponent, IApiFetcher } from "../ApiTesterApp";

export const tracksTopRatedAlbumsGet: IApiFetcher = async ({
  utoken,
  omitUserAgent = false,
  filterOn = false,
}: {
  utoken: string;
  omitUserAgent?: boolean;
  filterOn?: boolean;
}) => {
  const headers: AxiosRequestHeaders = {};
  if (!omitUserAgent) {
    headers["User-Agent"] = "I:2.5.0(256)";
  }
  headers["utoken"] = utoken;

  const response = await axios.get<any>(`${HOSTNAME}${tracksTopRatedAlbumsGet.url}`, {
    headers,
    params: {
      filterOn
    }
  });
  return response.data;
};
tracksTopRatedAlbumsGet.url = "/wp-json/wp/v3/tracks/top_rated_albums";
tracksTopRatedAlbumsGet.method = 'GET';

const TracksTopRatedAlbums: ApiTesterComponent = ({
  loginData,
}: {
  loginData: ILoginData2 | null;
}) => {
  const filterOnRef = useRef<HTMLInputElement>(null);
  const [data, setData] = useState<string>("");
  const [loading, setIsLoading] = useState<boolean>(false);

  const onFetch = () => {
    if (!loginData?.token) return;

    setIsLoading(true);
    tracksTopRatedAlbumsGet({
      utoken: loginData.token,
      omitUserAgent: true,
      filterOn: filterOnRef.current?.checked ?? false
    }).then((data) => {
      setIsLoading(false);
      setData(JSON.stringify(data, null, 2));
    });
  };

  return (
    <div>
      <h3>TracksTopRatedAlbums</h3>

      <label className="block">
        <span className="inline-block mr-2">Filter On</span>
        <input className="border px-2 py-1" type="checkbox" ref={filterOnRef} />
      </label>
      <button onClick={onFetch}>Fetch</button>
      <pre>{loading ? "Loading..." : data}</pre>
    </div>
  );
};

TracksTopRatedAlbums.fetcher = tracksTopRatedAlbumsGet;

export default TracksTopRatedAlbums;
